import axios from 'axios';
import getActionPaneUrl from './actionPaneUrl';
import { configureHttpHeaders, onSuccess, onError } from './apiHelpers';
import { VITE_IMAGE_MATCHER_API } from 'Constants/appEnvConstants'

const baseUrl = getActionPaneUrl();

function post(postUrl, postData) {
  return axios({
    method: 'post',
    url: `${baseUrl}${postUrl}`,
    data: postData,
  })
    .then(onSuccess)
    .catch(onError);
}
function put(putUrl, putData) {
  return axios.put(`${baseUrl}${putUrl}`, putData).then(onSuccess).catch(onError);
}

function get(url, searchInputDetails) {
  let pathVariables = '';
  let separator = '';
  // eslint-disable-next-line no-restricted-syntax, no-unused-vars
  for (const key in searchInputDetails) {
    pathVariables = `${pathVariables + separator + key}=${searchInputDetails[key]}`;
    separator = '&';
  }
  return axios.get(`${baseUrl}${url}?${pathVariables}`).then(onSuccess).catch(onError);
}

export default {
  postActionPaneData,
  updateActionPaneData,
  submitRespondToIssuer,
};
export function getActionDescriptions(url, searchInputDetails) {
  configureHttpHeaders(axios);
  return get(url, searchInputDetails);
}

export function postActionPaneData(actionPaneObject, url) {
  configureHttpHeaders(axios);
  return post(`${url}`, actionPaneObject);
}
export function updateActionPaneData(actionPaneObject, url) {
  configureHttpHeaders(axios);
  return put(`${url}`, actionPaneObject);
}

export function submitRespondToIssuer(respondIssuerObject) {
  const Url = 'api/v1/record/issuer/response/';
  configureHttpHeaders(axios);
  // eslint-disable-next-line no-undef
  return post(`${VITE_IMAGE_MATCHER_API + Url}`, respondIssuerObject);
}
